module.exports = __webpack_public_path__ + "media/components/src/assets/images/embedded_parts/company1-285238c5695ef5abb510b57b0e25fd91.jpg";